<script setup>
  import CompleteReport from '@/components/CompleteReport.vue';          
</script>

<template>
  <Suspense>
    <CompleteReport />
  </Suspense>
</template>
